/** Скидка промокода в любом из видов, в которых её отдаёт billing (заказ — discountPercent, витрина — discountPercentage). */
export interface PromocodeDiscountSource {
    discountType?: string | null
    discountPercent?: number | string | null
    discountPercentage?: number | string | null
    discountAmount?: number | string | null
}

/**
 * «-10%» или «-1 000 ₽». Промокод на сумму даёт рубли один раз на заказ, процентов у него нет —
 * без этой ветки подпись была бы «-undefined%».
 */
export function formatPromocodeDiscount(source: PromocodeDiscountSource | null | undefined): string {
    if (!source) return ''
    if (source.discountType === 'amount') {
        return `-${new Intl.NumberFormat('ru-RU').format(Number(source.discountAmount ?? 0))} ₽`
    }
    const percent = source.discountPercent ?? source.discountPercentage
    return percent == null ? '' : `-${percent}%`
}

/** «SALE20 -20%» — подпись промокода в счёте. */
export function formatPromocodeName(
    promocode: string | null | undefined,
    source: PromocodeDiscountSource | null | undefined
): string {
    if (!promocode) return ''
    const discount = formatPromocodeDiscount(source)
    return discount ? `${promocode} ${discount}` : promocode
}

/** promocodeData заказа: верхний уровень — первый промокод и общая скидка, `applied` — каждый промокод. */
export interface OrderPromocodeData extends PromocodeDiscountSource {
    promocode?: string | null
    applied?: Array<PromocodeDiscountSource & { promocode: string }> | null
}

/** Промокоды, давшие скидку в заказе. Заказы до нескольких промокодов знают один — на верхнем уровне. */
export function orderPromocodeCodes(promocodeData: OrderPromocodeData | null | undefined): string[] {
    if (Array.isArray(promocodeData?.applied)) return promocodeData!.applied.map(applied => applied.promocode)
    return promocodeData?.promocode ? [promocodeData.promocode] : []
}

/** «CHAT20 -20%, TARIFF -1 000 ₽» — все промокоды заказа одной подписью. */
export function formatOrderPromocodes(promocodeData: OrderPromocodeData | null | undefined): string {
    if (Array.isArray(promocodeData?.applied) && promocodeData!.applied.length) {
        return promocodeData!.applied
            .map(applied => formatPromocodeName(applied.promocode, applied))
            .join(', ')
    }
    return formatPromocodeName(promocodeData?.promocode, promocodeData)
}

/** «Промокод SALE -20%» или «Промокоды CHAT20 -20%, TARIFF -500 ₽»; пусто, если промокода нет. */
export function formatOrderPromocodesTitle(promocodeData: OrderPromocodeData | null | undefined): string {
    const names = formatOrderPromocodes(promocodeData)
    if (!names) return ''
    return `${orderPromocodeCodes(promocodeData).length > 1 ? 'Промокоды' : 'Промокод'} ${names}`
}
